import t from '../labels/labelling-utils';

export const legendItems = [
  { title: t('match.status.after.regular.time.shortname'), children: t('match.status.after.regular.time.fullname') },
  { title: t('match.status.after.extra.time.shortname'), children: t('match.status.after.extra.time.fullname') },
  {
    title: t('match.status.after.shootout.time.shortname'),
    children: t('match.status.after.shootout.time.fullname'),
  },
  { title: t('match.status.aggregate.shortname'), children: t('match.status.aggregate.fullname') },
];
